var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 16,
    viewBox: "0 0 50 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8588 5.0941C25.8303 7.31405 27.8633 8.5528 29.3947 9.28938C30.9682 10.045 31.4967 10.5297 31.4904 11.2055C31.4787 12.2397 30.2354 12.6962 29.0719 12.714C27.042 12.745 25.8617 12.173 24.9234 11.7405L24.1922 15.1176C25.1336 15.5458 26.8768 15.9192 28.6844 15.9355C32.9275 15.9355 35.7035 13.8683 35.7186 10.6631C35.7352 6.59521 30.0178 6.37005 30.0568 4.55184C30.0703 4.00051 30.6033 3.41217 31.7713 3.26258C32.3494 3.18702 33.9453 3.12919 35.7547 3.95155L36.4648 0.684078C35.4918 0.334392 34.2412 -0.000452042 32.6842 -0.000452042C28.6904 -0.000452042 25.8814 2.09497 25.8588 5.0941ZM43.2887 0.280993C42.5139 0.280993 41.8609 0.727065 41.5695 1.4116L35.5084 15.6955H39.7484L40.5922 13.3941H45.7734L46.2629 15.6955H50L46.7389 0.280993H43.2887ZM43.8818 4.44504L45.1055 10.2334H41.7543L43.8818 4.44504ZM20.718 0.281186L17.3758 15.6954H21.4162L24.7568 0.280801L20.718 0.281186ZM14.7408 0.281186L10.5354 10.7728L8.83418 1.85188C8.63457 0.85603 7.84629 0.280993 6.9709 0.280993H0.0962891L0 0.728607C1.41133 1.03087 3.01484 1.51839 3.98633 2.04003C4.58086 2.35868 4.75039 2.63723 4.9457 3.39444L8.16777 15.6955H12.4375L18.9836 0.280993L14.7408 0.281186Z",
    fill: "url(#paint0_linear_84_5214)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_84_5214",
    x1: 2298.7,
    y1: 47.9032,
    x2: 2344.23,
    y2: -1588.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosVisa);
export default __webpack_public_path__ + "static/media/logos_visa.abeb611e89294beb436e90d1994551ac.svg";
export { ForwardRef as ReactComponent };